import { setColorScheme } from '../../actions/app'
import { ColorScheme, SettingsType } from '../../constants/enums'
import { trackAnalyticsEvent } from '../../utilities/analytics'
import { useSettingSelector } from './useSettings'

export const useColorScheme = (eventLocation: string) => {
    const [setting] = useSettingSelector(SettingsType.DEFAULT, 'colorScheme')
    const colorScheme = setting ?? ColorScheme.system

    const changeColorScheme = (next: ColorScheme) => {
        setColorScheme(next, true)
        trackAnalyticsEvent({
            action: `ColorScheme_Toggle`,
            data: { colorScheme: next, eventLocation },
        })
    }

    return [colorScheme, changeColorScheme] as const
}
